'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_SIGN_ON_URL = exports.INTEGRATION_KEY = undefined;
exports.hasIntegration = hasIntegration;
exports.getSingleSignOnURL = getSingleSignOnURL;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _config = require('../utils/config');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var INTEGRATION_KEY = exports.INTEGRATION_KEY = 'sso';
var SINGLE_SIGN_ON_URL = exports.SINGLE_SIGN_ON_URL = 'identityProviderSingleSignOnUrl';

function hasIntegration(config) {
  return !_lodash2.default.isEmpty((0, _config.getValueForIntegration)(config, INTEGRATION_KEY, SINGLE_SIGN_ON_URL));
}

function getSingleSignOnURL(config) {
  return (0, _config.getValueForIntegration)(config, INTEGRATION_KEY, SINGLE_SIGN_ON_URL);
}